import React, { useCallback, useMemo } from 'react';
import { Route } from 'react-router-dom';
import PropTypes from 'prop-types';

import Routes from '../../routes';
import ScenarioManageMembersPage from './scenarioManageMembers/ScenarioManageMembersPage.component';
import ScenarioManageObligationsPage from './scenarioManageObligations/ScenarioManageObligationsPage.component';

import { RouteChildrenProps } from 'react-router';
import { Tab, Tabs } from '../../shared/tabs.component';

enum TabTypes {
  COMPANY_CODES = '/company-codes',
  OBLIGATIONS ='/obligations',
}

const ScenarioRulesPageComponent = ({ match, location, history }: RouteChildrenProps<{scenarioId: string}>) => {
  const activeTab = useMemo(() => match?.url
    ? location.pathname.substr(match.url.length)
    : ''
  , [location, match]);

  const changeTab = useCallback((_, tabName: TabTypes) => {
    history.push(`${match?.url}${tabName}`);
  }, [history, match?.url]);

  return (
    <div className="container-fluid page-content-container">
      <Tabs
        defaultValue={TabTypes.COMPANY_CODES}
        value={activeTab}
        onChange={changeTab}
        className="a-tab-bar-margin-10"
        size="md"
      >
        <Tab
          value={TabTypes.COMPANY_CODES}
          label="Company Codes"
        />
        <Tab
          value={TabTypes.OBLIGATIONS}
          label="Obligations"
        />
      </Tabs>
      <Route path={Routes.scenarios.rules.COMPANY_CODES} component={ScenarioManageMembersPage}/>
      <Route path={Routes.scenarios.rules.OBLIGATIONS} component={ScenarioManageObligationsPage}/>
    </div>

  );
};

ScenarioRulesPageComponent.propTypes = {
  match: PropTypes.shape({
    url: PropTypes.string.isRequired,
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

export default ScenarioRulesPageComponent;
